// const BASE_URL = 'https://washminutebackend.azurewebsites.net';
const BASE_URL = 'https://washminuteback.azurewebsites.net';
// https://washminuteback.azurewebsites.net/
// const BASE_URL = 'http://localhost:5001';

export default BASE_URL;